import './about-us.css'
import '../../common/card/card.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../../state/store';
import { useEffect } from 'react';
import { ITechStack } from './interfaces/ITechStack';
import {v4 as uuid} from 'uuid';
import TechStackService from '../../../services/techStackService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCloudArrowUp, faGears, faRoad, faSackDollar, faSitemap } from '@fortawesome/free-solid-svg-icons';

const AboutUsComponent = (): JSX.Element => {
  const phrases = useSelector((state: RootState) => state.phrases.value);
  const frontEndStack: Array<ITechStack> = TechStackService.getFrontEndStack();
  const backEndStack: Array<ITechStack> = TechStackService.getBackEndStack();
  const devOpsAndCloudStack: Array<ITechStack> = TechStackService.getDevOpsAndCloudStack();
  const databaseStack: Array<ITechStack> = TechStackService.getDatabaseStack();

  useEffect(() => {
    document.title = phrases[33];
  }, [phrases]);

  return <>
    <h1 className='about-us__company-heading'>{phrases[2]}</h1>
    <section className='about-us__section-1 card-component__outter-container card-component__company-card-container'>
      <div className='card-component__content-container card-component__company-card'>
        <p>
          {phrases[81]} {phrases[82]} {phrases[83]} {phrases[84]} {phrases[85]} {phrases[86]} {phrases[87]}
        </p>
        <p>
          {phrases[88]} {phrases[89]} {phrases[90]} {phrases[91]} {phrases[92]}
        </p>
      </div>
    </section>
    <h2 className='about-us__projects-heading'>{phrases[93]}</h2>
    <section className='about-us__section-2 card-component__outter-container card-component__company-card-container'>
      <div className='card-component__content-container card-component__company-card'>
        <p>{phrases[94]}</p>
        <ul>
            <li><FontAwesomeIcon icon={faSackDollar} className='fa-icon-green'></FontAwesomeIcon>{phrases[95]}</li>
            <li><FontAwesomeIcon icon={faRoad} className='fa-icon-gray'></FontAwesomeIcon>{phrases[96]}</li>
            <li><FontAwesomeIcon icon={faCalendarDays} className='fa-icon-gold'></FontAwesomeIcon>{phrases[97]}</li>
          </ul>
      </div>
    </section>
    <h2 className='about-us__expertise-heading'>{phrases[98]}</h2>
    <section className='about-us__section-3 card-component__outter-container card-component__company-card-container'>
      <div className='card-component__content-container card-component__company-card'>
      <p>{phrases[99]}</p>
        <ul>
          <li><FontAwesomeIcon icon={faSitemap} className='fa-icon-gray'></FontAwesomeIcon>{phrases[100]}</li>
          <li><FontAwesomeIcon icon={faCloudArrowUp} className='fa-icon-blue'></FontAwesomeIcon>{phrases[101]}</li>
          <li><FontAwesomeIcon icon={faGears}></FontAwesomeIcon>{phrases[102]}</li>
        </ul>
      </div>
    </section>
    <h2 className='about-us__tech-stack'>{phrases[103]}</h2>
    <div className='about-us__tech-stack-container'>
      <div>
        <h3 className='about-us__front-end-stack'>Front-end</h3>
        <ul className='tech-stack-list'>
          {
            frontEndStack.map((stack: ITechStack) => {
              return <li key={uuid()}>
                <img src={stack.imgSrc} />
                <span>{stack.description}</span>
              </li>
            })
          }
        </ul>
      </div>
      <div>
        <h3>Back-end</h3>
        <ul className='tech-stack-list'>
          {
            backEndStack.map((stack: ITechStack) => {
              return <li key={uuid()}>
                <img src={stack.imgSrc} />
                <span>{stack.description}</span>
              </li>
            })
          }
        </ul>
      </div>
      <div>
        <h3>Databases</h3>
        <ul className='tech-stack-list'>
          {
            databaseStack.map((stack: ITechStack) => {
              return <li key={uuid()}>
                <img src={stack.imgSrc} />
                <span>{stack.description}</span>
              </li>
            })
          }
        </ul>
      </div>
      <div>
        <h3>DevOps & Cloud</h3>
        <ul className='tech-stack-list'>
          {
            devOpsAndCloudStack.map((stack: ITechStack) => {
              return <li key={uuid()}>
                <img src={stack.imgSrc} />
                <span>{stack.description}</span>
              </li>
            })
          }
        </ul>
      </div>
    </div>
  </>
}

export default AboutUsComponent
